import Vue from 'vue'
import VueRouter from 'vue-router'
// 404
const errorpage = () => import('../views/error/errorpage.vue')
// 登录
const login = () => import(/* webpackChunkName: "login_home_welcome" */ '../views/login/login.vue')
// 主页
const home = () => import(/* webpackChunkName: "login_home_welcome" */ '../views/home/home.vue')
// 欢迎页
const welcome = () => import(/* webpackChunkName: "login_home_welcome" */ '../views/home/welcome.vue')
const dataStatistics = () => import(/* webpackChunkName: "login_home_welcome" */ '../views/home/dataStatistics.vue')

// 平板答题H5
const welcomePad = () => import('../views/pad/welcome.vue')
const welcomePadStu = () => import('../views/pad/pad_welcome.vue')

const screen = () => import('../views/pad/screen.vue')
const semiScreen = () => import('../views/padMatch/semi/semiScreen.vue')
const answerPad = () => import('../views/pad/answer.vue')
const answerDone = () => import('../views/pad/answer_done.vue')
const loginPad = () => import('../views/pad/login.vue')
const rankScreen = () => import('../views/pad/rank.vue')

// 复赛答题 H5
const stuLogin = () => import('../views/padMatch/stuLogin.vue')
const semiRank = () => import('../views/padMatch/semi/semiRank.vue')
const semiWelcome = () => import('../views/padMatch/semi/semiWelcome.vue')
const padSemiBefore = () => import('../views/padMatch/semi/beforeEnter.vue')
const padSemiQuiz = () => import('../views/padMatch/semi/onlineQuizzes.vue')
const padSemiResult = () => import('../views/padMatch/semi/resultPage.vue')
const semiThirdRound = () => import('../views/padMatch/semi/semiThirdRound.vue')
const semiThirdAnswer = () => import('../views/padMatch/semi/semiThirdAnswer.vue')

// 第三季国赛第二轮 平板答题
const userLoginFinal3round2 = () => import('../views/padMatch/final/userLoginFinal3round2.vue')
const userAnswerFinal3round2 = () => import('../views/padMatch/final/userAnswerFinal3round2.vue')
const welcomeFinal3round2 = () => import('../views/padMatch/final/welcomeFinal3round2.vue')
const screenFinal3round2 = () => import('../views/padMatch/final/screenFinal3round2.vue')
const rankFinal3round2 = () => import('../views/padMatch/final/rankFinal3round2.vue')

// const semiThirdAnswer = () => import('../views/padMatch/semi/semiThirdAnswer.vue')

// 赛务管理-个人赛赛务管理-个人赛
const individualRaceManagement = () => import('../views/home/raceManagement/individual_management/individual_manage_homeview/individual_race_management.vue')
// 赛务管理-个人赛赛务管理-初赛
const preliminaryRaceManagement = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/preliminary_raceManagement.vue')
// 赛务管理-个人赛赛务管理-复赛
const rematchRaceManagement = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/rematch_raceManagement.vue')
// 考务管理-个人赛赛务管理-国赛有组别
const nationalgroupRaceManagement = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/nationalgroup_raceManagement.vue')
// 考务管理-个人赛赛务管理-总决选报到
const checkIn = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/sign_in/check_in.vue')
// 考务管理-个人赛赛务管理-有组别抽签
const groupDraw = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/sign_in/group_draw.vue')
// 考务管理-个人赛赛务管理-无组别抽签
const noneGroupDraw = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/sign_in/none_group_draw.vue')
// 考务管理-个人赛赛务管理-国赛有组别
const nationalEnglishPlayerInfo = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/national_english_playerInfo.vue')
// 赛务管理-个人赛赛务管理-初赛-个人赛考量信息
const bSchoolConsiderations = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_considerations.vue')
// 赛务管理-个人赛赛务管理-初赛-个人赛考量信息-个人赛考量信息详情
const bSchoolManagementDetail = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_management_detail.vue')
// 赛务管理-个人赛赛务管理-比赛时间管理
const individualGametimeManage = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_gametime_manage.vue')
// 赛务管理-个人赛赛务管理-线下考场管理
const examinationRoomList = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examinationRoom/examination_room_list.vue')
// 赛务管理-个人赛赛务管理-国赛考场管理
const examinationNationalRoomList = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examinationRoom/examination_national_room_list.vue')
// 赛务管理-个人赛赛务管理-国赛考场详情
const examinationNationalRoomDetail = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examinationRoom/examination_national_room_detail.vue')
const examinationRoomDetails = () => import('../views/home/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examinationRoom/examination_room_details.vue')
// 赛务管理-个人赛赛务管理-参赛码管理
const semiFinalFormCode = () => import('../views/home/raceManagement/individual_management/semi_final_form_code/semi_final_form_code.vue')
// 赛务管理-个人赛赛务管理-优惠券管理
const coupon = () => import('../views/home/raceManagement/individual_management/coupon.vue')
// 赛务管理-个人赛赛务管理-优惠券管理
const couponDetail = () => import('../views/home/raceManagement/individual_management/coupon_detail.vue')

// 赛务管理-个人赛赛务管理-团体赛
const teamRaceManagement = () => import('../views/home/raceManagement/team_management/team_manage_homeview/team_race_management.vue')

// 考务管理-个人赛考务管理-初选
const examinationHomeManage = () => import('../views/home/examination_Management/individual_examination_management/examination_home_manage/examination_home_manage.vue')
// 考务管理-个人赛考务管理-初选-成绩查询
const scheduleIndividualCompetition = () => import('../views/home/examination_Management/individual_examination_management/schedule_competitions/schedule_individual_competition.vue')
// 考务管理-个人赛考务管理-初选-答题详情
const individualAnswerResult = () => import('../views/home/examination_Management/individual_examination_management/schedule_competitions/schedule_Childview/individual_answer_result.vue')
// 考务管理-个人赛考务管理-复选-成绩查询
const scheduleRematchCompetition = () => import('../views/home/examination_Management/individual_examination_management/schedule_competitions/schedule_rematch_competition.vue')
// 考务管理-团体赛考务管理
const examinationTeamhomeManage = () => import('../views/home/examination_Management/team_examination_management/examination_teamhome_manage.vue')
// 考务管理-表单答题管理
const formAnswerScore = () => import('../views/home/examination_Management/individual_examination_management/form_answer_score.vue')
// 考务管理-练习题答题管理
const exerciseAnswerScore = () => import('../views/home/examination_Management/individual_examination_management/exercise_answer_score.vue')
const exerciseAnswerResult = () => import('../views/home/examination_Management/individual_examination_management/exercise_answer_result.vue')
// 考务管理-全国总决选答题详情
const finalAnswer = () => import('../views/home/examination_Management/final_answer_detail.vue')
// /examination_Management/individual_examination_management/schedule_competitions/schedule_nationalgroup_competition
// 系统数据管理-系统学校基础信息
const sysSchoolInfomation = () => import('../views/home/system_data_Management/system_school_infomation.vue')
// 系统数据管理-系统赛区管理
const systemCompetitionManagement = () => import('../views/home/system_data_Management/system_competition_management.vue')
// 系统数据管理-系统赛区详情
const systemCompetitionDetails = () => import('../views/home/system_data_Management/system_competition_details.vue')
// 系统数据管理-系统学校基础信息-学校信息详情
const systemSchoolInfomationDetail = () => import('../views/home/system_data_Management/system_school_infomation_detail.vue')
// 系统数据管理-系统操作日志信息
const systemOperationLog = () => import('../views/home/system_data_Management/system_operation_log.vue')

// B端数据管理-首页
const bDataManagement = () => import('../views/home/b_data_Management/b_data_management.vue')
// B端数据管理-学校信息管理
const bSchoolManagement = () => import('../views/home/b_data_Management/b_school_management.vue')
// B端数据管理-赛区信息管理
const bDivisionManagement = () => import('../views/home/b_data_Management/b_division_management.vue')
// B端数据管理-赛点信息管理
const bMatchpointManagement = () => import('../views/home/b_data_Management/b_matchpoint_management.vue')

// C端数据管理-首页
const cDataManagementHome = () => import('../views/home/c_data_Management/c_data_management_home.vue')
// C端数据管理-注册信息查看
const cPlayerRegistInfo = () => import('../views/home/c_data_Management/c_player_registInfo.vue')
// C端数据管理-注册信息详情
const cPlayerRegistInfoDetails = () => import('../views/home/c_data_Management/c_player_registInfo_details.vue')
// C端数据管理-教师子女管理
const cPlayerTeacherinfoChild = () => import('../views/home/c_data_Management/c_player_teacherinfo_child.vue')

// C端数据管理-教师信息管理
const cPlayerTeacherinfo = () => import('../views/home/c_data_Management/c_player_teacherinfo.vue')
// 意见反馈
const feedback = () => import('../views/home/c_data_Management/feedback.vue')

// 产品管理-字库管理
const thesaurusManagement = () => import('../views/home/product_Management/thesaurus_management.vue')
// 产品管理-课程订单管理-学校订单管理
const courseSchoolorderManagement = () => import('../views/home/product_Management/course_schoolorder_management.vue')
// 产品管理-课程订单管理-教师订单管理
const courseTeacherorderManagement = () => import('../views/home/product_Management/course_teacherorder_management.vue')
// 产品管理-开通课程订单管理
const courseOpenManagement = () => import('../views/home/product_Management/course_open_management.vue')
// 产品管理-兑换码管理
const productcodeManagement = () => import('../views/home/product_Management/productcode_management.vue')
// 产品管理-海外兑换码管理
const bExchangeCodeManagement = () => import('../views/home/product_Management/b_exchange_code_management.vue')
// 产品管理-订单管理
const productManagement = () => import('../views/home/product_Management/product_management.vue')
// 产品管理-订单管理-退费订单
const productReturnManagement = () => import('../views/home/product_Management/product_return_management.vue')
// 产品管理-订单管理-订单详情
const productReturnDetail = () => import('../views/home/product_Management/product_return_detail.vue')
// 产品管理-首页
const productManagementHome = () => import('../views/home/product_Management/product_management_home.vue')
// 产品管理-订单管理-订单详情
const productDetailManagement = () => import('../views/home/product_Management/product_detail_management.vue')
// 产品管理-开通产品
const productOpen = () => import('../views/home/product_Management/product_open.vue')

// 学术管理-字库管理
const academicFontManagement = () => import('../views/home/academic_Management/academic_font_management/academic_font_management.vue')
const academicFontManagementHome = () => import('../views/home/academic_Management/academic_font_management/academic_font_management_home.vue')
const wordGroup = () => import('../views/home/academic_Management/academic_font_management/academic_work_group.vue')
// 学术管理-标签管理
const tagManagement = () => import('../views/home/tags/tags_list.vue')
// 学术管理-课程管理
const academicCourseManagement = () => import('../views/home/academic_Management/academic_course_management/academic_course_management.vue')
// 学术管理-课程管理-新增课程
const academicCourseDetail = () => import('../views/home/academic_Management/academic_course_management/academic_course_detail.vue')
// 学术管理-裁判系统
const refereeFinalManagement = () => import('../views/home/referee/referee_final_operate.vue')
const refereeManagement = () => import('../views/home/referee/referee_operate.vue')
const refereeHome = () => import('../views/home/referee/referee_home.vue')
// 学术管理-试卷管理
const papers = () => import('../views/home/paper/paper_list.vue')
const paperDetail = () => import('../views/home/paper/paper_detail_list.vue')
const padPaperDetail = () => import('../views/home/paper/pad_paper_detail_list.vue')

// 系统管理-首页
const systemHome = () => import('../views/home/system_Management/system_management_home.vue')
// 系统管理-账号管理
const userManagement = () => import('../views/home/system_Management/account.vue')
// 系统管理-轮播图管理
const bannerManagement = () => import('../views/home/system_Management/banner.vue')
// 系统管理-字典
const dictManagement = () => import('../views/home/system_Management/dictionary/dictionary.vue')
const dictChild = () => import('../views/home/system_Management/dictionary/dictionary_child.vue')
// 系统管理-赛季管理
const season = () => import('../views/home/system_Management/season.vue')
// 系统管理-赛程管理
const race = () => import('../views/home/system_Management/race.vue')
// 系统管理-部门管理
const systemManagementSection = () => import('../views/home/system_Management/system_management_section.vue')
// 系统管理-岗位管理
const systemManagementPosition = () => import('../views/home/system_Management/system_management_position.vue')
// 系统管理-权限管理
const systemManagementAuthority = () => import('../views/home/system_Management/system_management_authority.vue')
// 系统管理-用户列表
const systemUserManagement = () => import('../views/home/system_Management/system_management_user.vue')

// 海外版块
const overseasIndex = () => import('../views/home/overseas_Management/overseasIndex.vue')
// 海外兑换码申请记录
const overseasCodeApplyfor = () => import('../views/home/overseas_Management/overseasCodeApplyfor.vue')
// 海外组委会申请信息
const overseasCommitteeApplyfor = () => import('../views/home/overseas_Management/overseasCommitteeApplyfor.vue')
// 海外联系我们管理
const overseasContactUsManagement = () => import('../views/home/overseas_Management/overseasContactUsManagement.vue')
// 海外全球赛报名管理
const nationalOverseasManagement = () => import('../views/home/overseas_Management/nationalOverseasManagement.vue')
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '*',
      name: '404',
      component: errorpage
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/pad/welcome',
      component: welcomePad
    },
    {
      path: '/pad/pw',
      component: welcomePadStu
    },
    {
      path: '/pad/screen',
      component: screen
    },
    {
      path: '/pad/semiScreen',
      component: semiScreen
    },
    {
      path: '/pad/answer',
      component: answerPad
    },
    {
      path: '/pad/done',
      component: answerDone
    },
    {
      path: '/pad/rank',
      component: rankScreen
    },
    {
      path: '/pad/login',
      component: loginPad
    },
    {
      path: '/stuLogin',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: stuLogin
    },
    {
      path: '/semiRank',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: semiRank
    },
    {
      path: '/semiWelcome',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: semiWelcome
    },
    {
      path: '/padSemiBefore',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: padSemiBefore
    },
    {
      path: '/padSemiQuiz',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: padSemiQuiz
    },
    {
      path: '/padSemiResult',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: padSemiResult
    },
    {
      path: '/semiThirdRound',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: semiThirdRound
    },
    {
      path: '/userLoginFinal3round2',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: userLoginFinal3round2
    },
    {
      path: '/userAnswerFinal3round2',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: userAnswerFinal3round2
    },
    {
      path: '/welcomeFinal3round2',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: welcomeFinal3round2
    },
    {
      path: '/screenFinal3round2',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: screenFinal3round2
    },
    {
      path: '/rankFinal3round2',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: rankFinal3round2
    },
    {
      path: '/semiThirdAnswer',
      meta: {
        title: 'CEBSB | Chinese English Bilingual Spelling Bee'
      },
      component: semiThirdAnswer
    },
    {
      path: '/home',
      component: home,
      redirect: '/welcome',
      children: [
        {
          path: '/welcome',
          component: welcome
        },
        {
          path: '/dataStatistics',
          component: dataStatistics
        },
        {
          path: '/system_data_Management/system_school_infomation_detail',
          component: systemSchoolInfomationDetail
        },
        {
          path: '/system_data_Management/system_operation_log',
          component: systemOperationLog
        },
        {
          path: '/c_data_Management/c_data_management_home',
          component: cDataManagementHome
        },
        {
          path: '/c_data_Management/c_player_registInfo',
          component: cPlayerRegistInfo
        },
        {
          path: '/c_data_Management/c_player_registInfo_details',
          component: cPlayerRegistInfoDetails
        },
        {
          path: '/c_data_Management/c_player_teacherinfo_child',
          component: cPlayerTeacherinfoChild
        },
        {
          path: '/c_data_Management/c_player_teacherinfo',
          component: cPlayerTeacherinfo
        },
        {
          path: '/c_data_Management/feedback',
          component: feedback
        },
        {
          path: '/system_data_Management/system_school_infomation',
          component: sysSchoolInfomation
        },
        {
          path: '/system_data_Management/system_competition_management',
          component: systemCompetitionManagement
        },
        {
          path: '/system_data_Management/system_competition_details',
          component: systemCompetitionDetails
        },
        {
          path: '/b_data_Management/b_data_management',
          component: bDataManagement
        },
        {
          path: '/b_data_Management/b_school_management',
          component: bSchoolManagement
        },
        {
          path: '/b_data_Management/b_division_management',
          component: bDivisionManagement
        },
        {
          path: '/b_data_Management/b_matchpoint_management',
          component: bMatchpointManagement
        },
        {
          path: '/product_Management/b_exchange_code_management',
          component: bExchangeCodeManagement
        },
        {
          path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
          component: individualRaceManagement
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_considerations',
          component: bSchoolConsiderations
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_management_detail',
          component: bSchoolManagementDetail
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_gametime_manage',
          component: individualGametimeManage
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_list',
          component: examinationRoomList
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_national_room_list',
          component: examinationNationalRoomList
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_national_room_detail',
          component: examinationNationalRoomDetail
        },
        {
          path: '/raceManagement/individual_management/semi_final_form_code',
          component: semiFinalFormCode
        },
        {
          path: '/raceManagement/individual_management/coupon',
          component: coupon
        },
        {
          path: '/raceManagement/individual_management/couponDetail',
          component: couponDetail
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_details',
          component: examinationRoomDetails
        },
        {
          path: '/product_Management/thesaurus_management',
          component: thesaurusManagement
        },
        {
          path: '/product_Management/course_open_management',
          component: courseOpenManagement
        },
        {
          path: '/product_Management/product_management',
          component: productManagement,
          meta: {
            keepAlive: true // 缓存，保存状态，用于页面返回不刷新
          }
        },
        {
          path: '/product_Management/product_management_home',
          component: productManagementHome
        },
        {
          path: '/product_Management/product_return_management',
          component: productReturnManagement,
          meta: {
            keepAlive: true // 缓存，保存状态，用于页面返回不刷新
          }
        },
        {
          path: '/product_Management/product_return_detail',
          component: productReturnDetail
        },
        {
          path: '/product_Management/productcode_management',
          component: productcodeManagement
        },
        {
          path: '/product_Management/course_schoolorder_management',
          component: courseSchoolorderManagement
        },
        {
          path: '/product_Management/course_teacherorder_management',
          component: courseTeacherorderManagement
        },
        {
          path: '/product_Management/product_detail_management',
          component: productDetailManagement
        },
        {
          path: '/product_Management/product_open',
          component: productOpen
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/preliminary_raceManagement',
          component: preliminaryRaceManagement
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/rematch_raceManagement',
          component: rematchRaceManagement
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/nationalgroup_raceManagement',
          component: nationalgroupRaceManagement
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/check_in',
          component: checkIn
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/gd',
          component: groupDraw
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/ngd',
          component: noneGroupDraw
        },
        {
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/national_english_playerInfo',
          component: nationalEnglishPlayerInfo
        },
        {
          path: '/examination_Management/individual_examination_management/examination_home_manage/examination_home_manage',
          component: examinationHomeManage
        },
        {
          path: '/examination_Management/individual_examination_management/schedule_competitions/schedule_individual_competition',
          component: scheduleIndividualCompetition,
          meta: {
            keepAlive: true // 缓存，保存状态，用于页面返回不刷新
          }
        },
        {
          path: '/schedule_Childview/individual_answer_result',
          component: individualAnswerResult
        },
        {
          path: '/examination_Management/individual_examination_management/schedule_competitions/schedule_rematch_competition',
          component: scheduleRematchCompetition,
          meta: {
            keepAlive: false // 缓存，保存状态，用于页面返回不刷新
          }
        },
        {
          path: '/examination_Management/team_examination_management/examination_teamhome_manage',
          component: examinationTeamhomeManage
        },
        {
          path: '/examination_Management/fas',
          component: formAnswerScore
        },
        {
          path: '/examination_Management/eas',
          component: exerciseAnswerScore
        },
        {
          path: '/examination_Management/eas/detail',
          component: exerciseAnswerResult
        },
        {
          path: '/examination_Management/final_answer',
          component: finalAnswer
        },
        {
          path: '/raceManagement/team_management/team_race_management',
          component: teamRaceManagement
        },
        {
          path: '/academic_Management/academic_font_management/academic_font_management',
          component: academicFontManagement
        },
        {
          path: '/academic_Management/academic_font_management/academic_font_management_home',
          component: academicFontManagementHome
        },
        {
          path: '/academic_Management/tags/list',
          component: tagManagement
        },
        {
          path: '/academic_Management/word_group/list',
          component: wordGroup
        },
        {
          path: '/academic_Management/academic_course_management/academic_course_management',
          component: academicCourseManagement,
          meta: {
            keepAlive: true // 缓存，保存状态，用于页面返回不刷新
          }
        },
        {
          path: '/academic_Management/academic_course_management/academic_course_detail',
          component: academicCourseDetail
        },
        {
          path: '/academic_Management/rm',
          component: refereeManagement
        },
        {
          path: '/academic_Management/refereeFinalManagement',
          component: refereeFinalManagement
        },
        {
          path: '/academic_Management/rh',
          component: refereeHome
        },
        {
          path: '/academic_Management/paper',
          component: papers
        },
        {
          path: '/academic_Management/paper_detail',
          component: paperDetail
        },
        {
          path: '/academic_Management/pad_paper_detail_list',
          component: padPaperDetail
        },
        {
          path: '/system/account',
          component: userManagement
        },
        {
          path: '/system/banner',
          component: bannerManagement
        },
        {
          path: '/system/dict',
          component: dictManagement
        },
        {
          path: '/system/season',
          component: season
        },
        {
          path: '/system/race',
          component: race
        },
        {
          path: '/system/dict/data',
          component: dictChild
        },
        {
          path: '/system/home',
          component: systemHome
        },
        {
          path: '/system_Management/system_management_user',
          component: systemUserManagement
        },
        {
          path: '/system_Management/system_management_section',
          component: systemManagementSection
        },
        {
          path: '/system_Management/system_management_position',
          component: systemManagementPosition
        },
        {
          path: '/system_Management/system_management_authority',
          component: systemManagementAuthority
        }, {
          path: '/overseas_affairs_management',
          component: overseasIndex
        },
        {
          path: '/overseas_code_applyfor',
          component: overseasCodeApplyfor
        },
        {
          path: '/overseas_committee_applyfor',
          component: overseasCommitteeApplyfor
        },
        {
          path: '/overseas_contact_us_management',
          component: overseasContactUsManagement
        },
        {
          path: '/national_overseas_management',
          component: nationalOverseasManagement
        }
      ]
    }
  ]
})

// 挂载导航路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  } else {
    document.title = '汉英ERP管理系统'
  }
  const whiteList = [
    '/login',
    '/pad/welcome', // 大屏欢迎页
    '/pad/screen', // 大屏倒计时
    '/pad/answer', // pad答题
    '/pad/done', // pad提交
    '/pad/rank', // 大屏排名
    '/pad/login', // pad登录
    '/pad/pw', // pad欢迎页
    '/stuLogin', // 复选H5登录
    '/semiRank', // 复选排行榜
    '/padSemiBefore', // 复选平板答题
    '/padSemiQuiz', // 复选平板答题
    'padSemiResult', // 复选平板答题
    '/semiThirdRound', // 复选平板答题第三轮
    '/semiThirdAnswer', // 复选平板答题第三轮答案
    '/userLoginFinal3round2',
    '/userAnswerFinal3round2',
    '/welcomeFinal3round2',
    '/screenFinal3round2',
    '/rankFinal3round2'
  ]
  if (whiteList.includes(to.path)) return next()
  if (!localStorage.getItem('Authorization')) return next('/login')
  next()
})

export default router
